import React from "react";

const Tab = props => {
    const { children, title, classNames = [] } = props;

    return (
        <div className={classNames} role="tabpanel">
            <h2 className="mb-3">{title}</h2>
            {children}
        </div>
    );
};

export default Tab;



// WEBPACK FOOTER //
// ./web/src/components/company/company-form/Tab.jsx